import { render, staticRenderFns } from "./Toolbor.vue?vue&type=template&id=3dc26fd9&scoped=true"
import script from "./Toolbor.vue?vue&type=script&lang=js"
export * from "./Toolbor.vue?vue&type=script&lang=js"
import style0 from "./Toolbor.vue?vue&type=style&index=0&id=3dc26fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc26fd9",
  null
  
)

export default component.exports